// extracted by mini-css-extract-plugin
module.exports = {"root":"Notes_root__2J2nd","notes":"Notes_notes__Dxp5Q","note":"Notes_note__1TEqg","markdown":"Notes_markdown__2YQeM"};